<template>
    <div>
        <div class="title-wrapper">
            <a href="#">
                <div class="logo-wrapper" @click.prevent="activeContentChange('clear')">
                    <img class="logo" :src="activeConfig.main_logo" alt="">
                </div>
            </a>
        </div>
        <div class="nav-items-list">
            <nav-element v-for="(navItems,index) in activeConfig.nav" :key="index" :index="index" :nav-index="index"
                         :activeContent="activeContent"
                         :navItems.sync="navItems"></nav-element>
        </div>
    </div>
</template>

<script>
    import NavElement from './NavElement.vue'

    export default {
        props: ['brand', 'activeContent', 'activeConfig'],
        name: "Nav",
        methods: {
            isInstalledByType: function (type) {
                return this.$parent.isInstalledByType(type);
            },
            closeAllNav: function () {//close all navs
                for (let i = 0; i < this.activeConfig.nav.length; i++) {
                    this.activeConfig.nav[i].open = false;
                }
            },
            openNav: function (navType) {
                this.closeAllNav();
                let navToOpen = this.activeConfig.nav.find(configNav => {
                    if (configNav.subs.length > 0) {
                        return configNav.subs[0].type == navType;
                    }
                    return configNav.type == navType;
                });
                if(navToOpen){
                    navToOpen.open = true;
                }
            }, activeContentChange: function (content) {
                this.$parent.activeContentChange(content)
            }
        },
        components: {
            NavElement
        }
    }
</script>

<style scoped>
    .title-wrapper {
        background-color: #696969;
        text-align: center;
    }

    .title-wrapper a {
        padding: 27px 40px;
        text-decoration: none;
        display: block;
    }

    .logo-wrapper {
        text-align: left;
    }

    .logo {
        width: 150px;
    }

    .nav-items-list {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: calc(100% - 132px);
        overflow-y: auto;
        position: relative;
        background-color: #E0E0E0;
        border-bottom-left-radius: 10px;
    }

    /*
    *****************************
        safely
    *****************************
    */

    .safely .title-wrapper {
        background-color: #03a9f4;
        border-radius: 12px 0 0 0;

    }

    /*
    *****************************
        privately
    *****************************
    */

    .privately .title-wrapper {
        background-color: #00ccac;
    }

    .privately .logo-wrapper {
        text-align: center;
    }

    .privately .logo {
        width: 183px;
    }

    /*
    *****************************
        online-tools
    *****************************
    */

    .onlinetools .title-wrapper {
        background-color: #e6f9fb;
    }

    .onlinetools .title-wrapper a {
        padding: 8px 18px;
    }

    .onlinetools .logo {
        width: 240px;
    }

    .onlinetools .nav-items-list {
        height: calc(100% - 135px);
        background: #e6d5ad69;
    }

</style>